import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ContentsGroup from 'components/cms/ContentsGroup';
import { Flex } from '@certilogo/design-system';
import map from 'lodash/map';
import { Wrapper, Cell } from './styles';

const Grid = ({ colorType, style, cellContents, rowSize = 3, propsBag, completeAction }) => {
  useEffect(() => {
    if (propsBag.setSwipeable) {
      propsBag.setSwipeable(false);
    }
    return () => {
      if (propsBag.setSwipeable) {
        propsBag.setSwipeable(true);
      }
    };
  }, []);
  return (
    <Flex style={{ flexShrink: 0 }}>
      <Wrapper colorType={colorType} {...style}>
        {map(cellContents, ({ colSize, contents_group: contentsGroup, id }) => (
          <Cell width={`${(colSize / rowSize) * 100}%`} key={id}>
            <ContentsGroup
              data={contentsGroup}
              colorType={colorType}
              propsBag={propsBag}
              completeAction={completeAction}
            />
          </Cell>
        ))}
      </Wrapper>
    </Flex>
  );
};

Grid.propTypes = {
  colorType: PropTypes.string,
  cellContents: PropTypes.array,
  type: PropTypes.string,
  style: PropTypes.object,
  propsBag: PropTypes.object,
  rowSize: PropTypes.number,
  completeAction: PropTypes.func,
};

export default Grid;
